// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-type_tip[data-v-2ece67e6]{color:#909399;font-size:12px;line-height:1em}.btn-sf-del[data-v-2ece67e6]{cursor:pointer}.btn-sf-del[data-v-2ece67e6]:hover{color:red}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
